import React from 'react';
import { ButtonToolbar } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NEW_BAGGAGE_ITEM_STATUS } from '../../../../config/constants';
import { getBaggageItemById, putMarkDepuratedById } from '../../../../actions';
import ItemDepuratedButton from './ItemDepuratedButton';

const ItemToolbar = ({ itemId, status }) => (
  <ButtonToolbar className="pull-right">
    {status === NEW_BAGGAGE_ITEM_STATUS.UNCLAIMED.value && (
      <ItemDepuratedButton itemId={itemId} />
    )}
  </ButtonToolbar>
);

ItemToolbar.propTypes = {
  itemId: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};

const mapStateToProps = ({ BaggageUnit }) => ({
  loading: !BaggageUnit.Item.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchPutMarkDepuratedById: putMarkDepuratedById,
  dispatchGetBaggageItemById: getBaggageItemById,
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemToolbar);
